import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { NWMControls } from 'app/components/Controls/NWMControls.module';
import { ClientErrorComponent } from './client-error.component';

@NgModule({
    imports: [
        BrowserModule,
        RouterModule,
        NWMControls,
        ClientErrorComponent
    ],
    providers: []
})
export class ClientErrorModule { }
